module.exports = __webpack_public_path__ + "images/pages/for_business/sp/head_2d70843c1546f2f6dcc3b4aea76f8548.jpg";